import { SelectedWorkingStepDto } from 'services/APIs/InternalAPI/internal-api.contracts'

export type WorkingStepWithData = Omit<
  SelectedWorkingStepDto,
  'bomItemId' | 'bomItemActivityId'
> & {
  bomItemId?: string
  bomItemActivityId?: string
  bomItemActivityIds?: Record<string, string>
  label?: string
  formData?: Record<string, unknown> | null
  comment?: string
}

/**
 * Returns a key that uniquely identifies a working step instance within a
 * bom item. Prefers the (server assigned) activity id, since matching only
 * by working step type is ambiguous when a bom item has multiple activities
 * of the same working step type (e.g. two "Cleaning" activities). Falls back
 * to the working step type for not-yet-saved working steps that don't have
 * an activity id yet.
 */
export const getWorkingStepKey = (
  ws:
    | Pick<WorkingStepWithData, 'bomItemActivityId' | 'secondaryWorkingStep'>
    | null
    | undefined,
): string | undefined => ws?.bomItemActivityId || ws?.secondaryWorkingStep
